import z from 'zod'
import { createFileRoute } from '@tanstack/react-router'
import { CompanyExperiences } from '@/features/admin/company-experiences'

const searchSchema = z.object({
  page: z.number().optional().catch(1),
  pageSize: z.number().optional().catch(50),
  filter: z.string().optional().catch(''),
  hideZero: z.boolean().optional().catch(true),
})

export type CompanyExperiencesSearchParams = z.infer<typeof searchSchema>

export const Route = createFileRoute(
  '/_authenticated/admin/company-experiences'
)({
  validateSearch: searchSchema,
  component: CompanyExperiences,
})
